var Handlebars = require("/root/project/webapp/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<p>"
    + container.escapeExpression(__default(require("/root/project/webapp/src/common/ui/template/helper/i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"balus_template_body_user:nav.group-list.no-group.contact",{"name":"i18n","hash":{},"data":data}))
    + "</p>\n<a href=\"https://levii.co.jp/contact/\" target=\"_blank\"> https://levii.co.jp/contact/ </a>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./balus/ui/template/global-menu/modal/no-group-modal.hbs
// module id = 640
// module chunks = 0